// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-tooltip-container {
  position: relative;
  background: #ffffff;
  border: 1px solid #d7e0ea;
  border-inline-start: 4px solid #1f5da8;
  padding-block: 10px;
  padding-inline: 12px 14px;
  border-radius: 12px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);
  min-width: 160px;
}

.chart-tooltip-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
}

.chart-tooltip-value {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  align-items: center;
  margin-top: 2px;
}

.chart-tooltip-title {
  font-size: 12px;
  color: #64748b;
}

.chart-tooltip-number {
  font-size: 13px;
  font-weight: 700;
  color: #1f5da8;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/CustomChartTooltip/chart-tooltip.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF","sourcesContent":[".chart-tooltip-container {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #d7e0ea;\n  border-inline-start: 4px solid #1f5da8;\n  padding-block: 10px;\n  padding-inline: 12px 14px;\n  border-radius: 12px;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);\n  min-width: 160px;\n}\n\n.chart-tooltip-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.chart-tooltip-value {\n  display: flex;\n  justify-content: space-between;\n  gap: 6px;\n  align-items: center;\n  margin-top: 2px;\n}\n\n.chart-tooltip-title {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.chart-tooltip-number {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1f5da8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
